export default {
  order: null,
  orders: null,
  unsubscribeOrder: null,
  unsubscribeAllOrders: null,
  paymentMethods: [
    { id: "DEB_CRED", name: "Tarjeta de crédito/débito" },
    { id: "TRANSFER", name: "Transferencia" },
    { id: "YAPE", name: "Yape" },
    { id: "UPON_DELIVERY", name: "Contra entrega" },
    { id: "CASH", name: "Efectivo" },
  ],
  paymentUponDeliveryTypes: [
    { id: "DEB_CRED", name: "Tarjeta de crédito/débito" },
    { id: "PLIN", name: "Plin" },
    { id: "YAPE", name: "Yape" },
    { id: "CASH", name: "Efectivo" },
  ],
  paymentStates: [
    {
      id: "pago-pendiente",
      name: "Pago pendiente",
      hashtag: "#o{OrdenID}eppen",
      abrev: "pen",
    },
    {
      id: "procesando-pago",
      name: "Procesando pago",
      hashtag: "#o{OrdenID}eppro",
      abrev: "pro",
    },
    {
      id: "pago-rechazado",
      name: "Pago rechazado",
      hashtag: "#o{OrdenID}eprec",
      abrev: "rec",
    },
    {
      id: "pago-completado",
      name: "Pago completado",
      hashtag: "#o{OrdenID}epcom",
      abrev: "com",
    },
    {
      id: "pago-anulado",
      name: "Pago anulado",
      hashtag: "#o{OrdenID}epanu",
      abrev: "anu",
    },
  ],
  paymentStatesMap: {
    "pago-pendiente": {
      id: "pago-pendiente",
      name: "Pago pendiente",
      hashtag: "#o{OrdenID}eppen",
      abrev: "pen",
    },
    "procesando-pago": {
      id: "procesando-pago",
      name: "Procesando pago",
      hashtag: "#o{OrdenID}eppro",
      abrev: "pro",
    },
    "pago-rechazado": {
      id: "pago-rechazado",
      name: "Pago rechazado",
      hashtag: "#o{OrdenID}eprec",
      abrev: "rec",
    },
    "pago-completado": {
      id: "pago-completado",
      name: "Pago completado",
      hashtag: "#o{OrdenID}epcom",
      abrev: "com",
    },
    "pago-anulado": {
      id: "pago-anulado",
      name: "Pago anulado",
      hashtag: "#o{OrdenID}epanu",
      abrev: "anu",
    },
  },
  deliveryMethods: [
    { id: "store", name: "Entrega en tienda" },
    { id: "address", name: "Entrega a domicilio" },
    { id: "office", name: "Entrega a oficina" },
  ],
  deliveryStates: [
    {
      id: "pendiente-de-entrega",
      name: "Pendiente de entrega",
      hashtag: "#o{OrdenID}eepen",
      abrev: "pen",
    },
    {
      id: "enviando-pedido",
      name: "Enviando pedido",
      hashtag: "#o{OrdenID}eeenv",
      abrev: "env",
    },
    {
      id: "pedido-entregado",
      name: "Pedido entregado",
      hashtag: "#o{OrdenID}eeent",
      abrev: "ent",
    },
    {
      id: "pedido-no-recibido",
      name: "Pedido no recibido",
      hashtag: "#o{OrdenID}eenre",
      abrev: "nre",
    },
  ],
  deliveryStatesMap: {
    "pendiente-de-entrega": {
      id: "pendiente-de-entrega",
      name: "Pendiente de entrega",
      hashtag: "#o{OrdenID}eepen",
      abrev: "pen",
    },
    "enviando-pedido": {
      id: "enviando-pedido",
      name: "Enviando pedido",
      hashtag: "#o{OrdenID}eeenv",
      abrev: "env",
    },
    "pedido-entregado": {
      id: "pedido-entregado",
      name: "Pedido entregado",
      hashtag: "#o{OrdenID}eeent",
      abrev: "ent",
    },
    "pedido-no-recibido": {
      id: "pedido-no-recibido",
      name: "Pedido no recibido",
      hashtag: "#o{OrdenID}eenre",
      abrev: "nre",
    },
  },
  cart: [],
  cartIGV: 0,
};
